import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { InputGroup } from 'react-bootstrap'
import { FaIcon } from '../../../shared/components'

class CalendarInput extends Component {

  render() {
    return (
      <InputGroup>
        <input className="date-picker-input" readOnly={true} defaultValue={this.props.value} onClick={this.props.onClick} />
        <span className="input-group-addon" style={{ background: 'white' }}>
          <FaIcon icon="calendar-alt" style={{color: '#4F4F4F'}} />
        </span>
      </InputGroup>
    )
  }
}

CalendarInput.propTypes = {
  onClick: PropTypes.func,
  value: PropTypes.string,
}

export default CalendarInput
